import { ParsedField } from './typings';

const parseFieldKey = (fullFieldKey: string): ParsedField => {
  const match = fullFieldKey.match(/^(.*)\[(\d+)\].(.*)/);
  if (!match) {
    return {
      fieldKey: fullFieldKey,
      fullFieldKey,
      listFieldKey: null,
      rowIndex: null,
    };
  }

  const listFieldKey = match[1];
  const rowIndex = match[2] ? parseInt(match[2], 10) : null;
  const fieldKey = match[3];

  return {
    fieldKey,
    fullFieldKey,
    listFieldKey,
    rowIndex,
  };
};

export default parseFieldKey;